import SectionReviews from './SectionReviews';
export default SectionReviews;
